import { Injectable } from '@angular/core';

/**
 * Export to CSV for the warehousing reports.
 *
 * The reporting module builds its CSV inline in each screen. Five warehousing reports
 * doing the same thing would be five copies of the same quoting bug, so the download is
 * shared here. Values are quoted and embedded quotes doubled per RFC 4180 — product
 * names and warehouse names contain commas in real data, and the inline exports elsewhere
 * would split a row on them.
 */
@Injectable({
  providedIn: 'root'
})
export class ReportCsvService {

  /**
   * @param filename name to download as, `.csv` appended if missing
   * @param headers column headings
   * @param rows one array of cell values per row, same length and order as headers
   */
  download(filename: string, headers: string[], rows: any[][]) {

    if (!headers || headers.length === 0) {
      throw new Error('report csv service: you must supply headers');
    }

    const lines: string[] = [headers.map(h => this.cell(h)).join(',')];

    (rows ? rows : []).forEach((row: any[]) => {
      lines.push(row.map(value => this.cell(value)).join(','));
    });

    const data: string = lines.join('\n');
    const name: string = filename.toLowerCase().endsWith('.csv') ? filename : filename + '.csv';

    const link = document.createElement('a');
    link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(data));
    link.setAttribute('download', name);
    document.body.appendChild(link); // Required for FF

    link.click();

    document.body.removeChild(link);
  }

  /**
   * A null or undefined cell becomes empty rather than the string "null", which is what
   * a plain template would have written into the file.
   */
  private cell(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }

    return '"' + String(value).replace(/"/g, '""') + '"';
  }
}
